import React, { useState, useEffect } from 'react';
import { Button, Box, ButtonGroup, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import dietService from '../../services/diet_service';
import { sumBy } from 'lodash';
import axios from 'axios';

const ManagementDietPage = () => {
  const navigate = useNavigate();
  const [diets, setDiets] = useState([]);

  // Using Redux for saving token
  // Token is used later
  // const token = useSelector((state) => state.token);

  const fetchDiets = async () => {
    try {
      const dietClassesResponse = await dietService.getAllDietClasses();
      const dietMenusResponse = await dietService.getAllDietClassMenus();
      console.log("managementDiet.jsx - fetched diet classes:", dietClassesResponse);
      console.log("managementDiet.jsx - fetched diet class menus for a diet class:", dietMenusResponse);

      if (dietClassesResponse.data && dietMenusResponse.data) {
        const dietsWithTotalCalories = dietClassesResponse.data.map(diet => {
          const relatedMenus = dietMenusResponse.data.filter(menu => menu.diet_class_id === diet.id);
          return {
            ...diet,
            totalCalories: sumBy(relatedMenus, 'calories')
          };
        });
        setDiets(dietsWithTotalCalories)
      }
    } catch (error) {
      console.error(error);
    }
  };  

  const handleDeleteDietClassMenu = async (id) => {
    const response = dietService.deleteOneDietClassMenu(id);
    return response
  }

  const handleDelete = async (id) => {
    try {
      const getOneDietClass = await dietService.getOneDietClass(id);
      const getAllDietClassMenu = await dietService.getAllDietClassMenus();

      const dietClassId = getOneDietClass.data.id

      const data = await Promise.all(getAllDietClassMenu.data.map( async menu => {
        if(menu.diet_class_id === dietClassId){
          return handleDeleteDietClassMenu(menu.id)
        }
        return;
      }))

      const response = await dietService.deleteOneDietClass(id);
      console.log(response);
      if (response.data) {
        alert("Diet class Deleted successfully");
        window.location.reload();
      } else {
        alert("Diet class Deleted successfully");
        window.location.reload();
      }

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchDiets();
  }, []);

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Typography sx={{ fontFamily: 'Titillium Web',marginLeft: '280px' , mt: 2, fontWeight: 'bold' }} variant="h6" component="h3" color="#1C1C1E" mb={1}>
          Manajemen Program Makanan
      </Typography>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Diet" />
      </Box>
      <Box sx={{ fontFamily: 'inherit' }}>
        <Button sx={{ left: 280, boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white', mt: 2, mb: 2 }} onClick={() => navigate('/dashboard/management/diet/add')}>
          <Typography variant="subtitle1" sx={{ fontFamily: 'Titillium Web', fontWeight: 'bold', fontSize: 14 }}>
            + Tambah Diet
          </Typography>
        </Button>

        <Box sx={{ marginLeft: '280px', marginRight: '10px' }} display="flex" justifyContent="space-between" mb={2}>
          <TableContainer component={Paper} sx={{ fontFamily: 'Titillium Web', maxHeight: '600px' }}>
            <Table aria-label='Daftar Diet' stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>ID Diet</TableCell>
                  <TableCell>Nama Diet</TableCell>
                  <TableCell>Kalori</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  diets.map(row => {
                    return (
                      <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.totalCalories}</TableCell>
                        <TableCell>
                          <ButtonGroup variant="outlined" aria-label="outlined button group">
                            <Button variant="contained" color="warning" onClick={() => navigate(`/dashboard/management/diet/update/${row.id}`)}>Edit</Button>
                            <Button variant="contained" color="error" onClick={() => handleDelete(row.id)}>Delete</Button>
                          </ButtonGroup>
                        </TableCell>

                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

      </Box>
    </>
  );
};

export default ManagementDietPage;
